module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_11",
    staticStyle: {
      "margin-top": "20%"
    }
  }, [_c('span', {
    staticClass: "text_4"
  }, [_vm._v("“We can only learn to love by loving.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }, [_c('span', {
    staticClass: "text_4"
  }, [_vm._v("— Iris Murdoch")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_11"
  }, [_c('span', {
    staticClass: "text_4"
  }, [_vm._v("“There is some soul of goodness in things evil, would men observingly distill it out.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }, [_c('span', {
    staticClass: "text_4"
  }, [_vm._v("— Shakespeare")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b8ead4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_004.vue
// module id = 69
// module chunks = 0